<template>
  <div>
    <a-col :span="24">
      <a-card title="Periodo de vacaciones" v-if="empleadoseleccionado">
        <g-master name="periodo_vacaciones"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="parentData"
                  @action="masterAction"
                  :actions="master.actions"
                  ref="masterComponent"
                  modalWidth="90%"
                  @params="paramsTable"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha inicial')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 v-decorator="['htv_ini', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha final')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 v-decorator="['htv_end', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Días')">
                  <a-input-number v-bind="fiOptions" style="width: 100%"
                                  v-decorator="['htv_days', { rules: [
                              { required: true, message: 'Valor requerido'},
                              { required: true, validator: validateDays, message: `Los días deben de ser menores o iguales a ${maxDias}` }
                              ], initialValue: maxDias }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Tiempo disfrute')">
                  <a-input-number v-bind="fiOptions" style="width: 100%"
                                  v-decorator="['htv_time', { rules: [{ required: false, message: 'Valor requerido' }]}]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Compensado en dinero')">
                  <a-input-number v-bind="fiOptions" style="width: 100%"
                                  v-decorator="['htv_comp', { rules: [{ required: false, message: 'Valor requerido' }]}]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            label="Tipo de vacaciones"
                            :formItemConfig="fiOptions"
                            :decorator="['id_h_type_vac', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                            :params="id_h_params">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Documento')">
                  <a-input
                    v-decorator="['htv_doc', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Comentario')">
                  <a-textarea autoSize
                              v-decorator="['htv_obs', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
        <template v-if="contract && mostrarBtnSolVacaciones">
          <btn-historico-vacaciones @modalOk="loadData" v-if="empleadoseleccionado" :p_id_emp="empleadoseleccionado"
                                    slot="extra"/>
        </template>
      </a-card>
    </a-col>
    <a-col :span="24">
      <a-card title="Historico de vacaciones" v-if="empleadoseleccionado && id_t_hist_vac">
        <historico-vacaciones
          :empleadoseleccionado="empleadoseleccionado"
          :id_t_hist_vac="id_t_hist_vac"
          :htv_days_hist_vac="htv_days"
          :contract="contract"
          ref="historico"
        />
      </a-card>
    </a-col>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['empleadoseleccionado', 'contract'],
    data () {
      return {
        fileNameExcel: 'periodo_vacaciones',
        paramsT: {},
        endpointExcel: 'hist_vac_/downloadExcel',
        maxDias: 15,
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        id_h_params: {
          h_lookup_type: 'TIPO_VACACION'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'hist_vac',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Fecha inicial', dataIndex: 'htv_ini_mask', sorter: true},
              {title: 'Fecha final', dataIndex: 'htv_end_mask', sorter: true},
              {title: 'Días', dataIndex: 'htv_days', sorter: true, align: 'right'},
              {title: 'Tiempo disfrute', dataIndex: 'htv_time', sorter: true, align: 'right'},
              {title: 'Compensado en dinero', dataIndex: 'htv_comp', sorter: true, align: 'right'},
              {title: 'Pendiente', dataIndex: 'pendiente', sorter: true, align: 'right'},
              {title: 'Tipo de vacaciones', dataIndex: 'h_type_vac', sorter: true},
              {title: 'Documento', dataIndex: 'htv_doc', sorter: true},
              {title: 'Comentario', dataIndex: 'htv_obs', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ],
            allowSelect: true,
            selectedRows: [],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return this.contract
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    return this.contract
                  }
                }
              ]
            }
          },
          modalFieldsSetup: [
            {name: 'htv_ini', type: 'date'},
            {name: 'htv_end', type: 'date'},
            {name: 'htv_days'},
            {name: 'htv_time'},
            {name: 'htv_comp'},
            {name: 'id_h_type_vac'},
            {name: 'htv_doc'},
            {name: 'htv_obs'}
          ],
          actions: [{
            name: 'masterCreate',
            text: 'Crear',
            permisos: [],
            props: {icon: 'plus', type: 'button'},
            fnVisible: () => !this.$userIsInrol('Query')
          }
          ]
        }
      }
    },
    mounted () {
      try {
        this.maxDias = parseInt(this.$getConfigValue('PERIODO_VACACIONES_MAXIMO_DIAS', 15))
      } catch (e) {
        this.maxDias = 15
      }
    },
    methods: {
      loadData () {
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
      },
      validateDays (rule, value, callback) {
        if (value <= this.maxDias) {
          callback()
        }
        callback('error')
      },
      masterAction (action) {
        switch (action.action) {
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!JsUtils.isEmpty(action.changedFields.htv_ini)) {
              if (JsUtils.isEmpty(action.changedFields.htv_ini.value)) {
                this.$refs.masterComponent.modal.form.setFieldsValue({
                  htv_ini: null
                })
              } else {
                let fechaFinal = action.changedFields.htv_ini.value.clone()
                fechaFinal.add(1, 'year')
                fechaFinal.subtract(1, 'd')
                this.$refs.masterComponent.modal.form.setFieldsValue({
                  htv_end: fechaFinal
                })
              }
            }
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      },
      id_t_hist_vac () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      },
      htv_days () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].htv_days : null
      },
      mostrarBtnSolVacaciones () {
        return this.$getConfigValue('MOSTRAR_BTN_SOL_VACACIONES_HIST_VACACIONES', 'NO') === 'SI'
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, ...this.parentData}
      }
    },
    watch: {
      contract () {
        if (!this.contract) {
          if (this.master.actions.length > 0) {
            this.master.actions.splice(0)
          }
        } else {
          if (this.master.actions.length === 0) {
            this.master.actions.push({
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'},
              fnVisible: () => !this.$userIsInrol('Query')
            })
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/PeriodoVacaciones.vue